<template>
  <div>
    <WelcomeHeader />

    <section class="ca-hero">
      <div class="ca-container">
        <span class="ca-badge">ফ্রি রিসোর্স</span>
        <h1>সাম্প্রতিক সমাচার</h1>
        <p>বিসিএস ও চাকরির প্রস্তুতির জন্য মাসভিত্তিক বাছাইকৃত কারেন্ট অ্যাফেয়ার্স — বাংলাদেশ, আন্তর্জাতিক, বিজ্ঞান ও প্রযুক্তি এবং ক্রীড়াঙ্গন।</p>
      </div>
    </section>

    <section class="ca-list">
      <div class="ca-container">
        <div class="ca-grid">
          <article
            v-for="issue in issues"
            :key="issue.key"
            class="ca-card"
            @click="goToIssue(issue)"
          >
            <div class="ca-card-top">
              <span class="ca-cal">📅</span>
              <div>
                <h2>{{ issue.label }}</h2>
                <span class="ca-count">{{ toBengali(issue.count) }} প্রশ্ন · {{ toBengali(issue.categories.length) }} বিষয়</span>
              </div>
            </div>
            <p class="ca-summary">{{ issue.summary }}</p>
            <div class="ca-chips">
              <span
                v-for="c in issue.categories"
                :key="c.key"
                class="ca-chip"
                :style="{ '--accent': c.accent }"
              >
                {{ c.name }} · {{ toBengali(c.items.length) }}
              </span>
            </div>
            <span class="ca-link">
              বিস্তারিত পড়ুন
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M13.267 4.209a.75.75 0 0 0-1.06 1.06l5.58 5.58H3.75a.75.75 0 0 0 0 1.5h14.037l-5.58 5.58a.75.75 0 1 0 1.06 1.06l6.868-6.867a.75.75 0 0 0 0-1.062l-6.868-6.851z" fill="currentColor"/>
              </svg>
            </span>
          </article>

          <article class="ca-card ca-card--soon">
            <div class="ca-card-top">
              <span class="ca-cal">🗓️</span>
              <div>
                <h2>পরবর্তী মাস</h2>
                <span class="ca-count">শীঘ্রই আসছে</span>
              </div>
            </div>
            <p class="ca-summary">প্রতি মাসের সাম্প্রতিক তথ্য এখানে যুক্ত হবে। নিয়মিত চোখ রাখুন।</p>
          </article>
        </div>
      </div>
    </section>

    <WelcomeFooter :hide-download="true" />
  </div>
</template>

<script>
import { onMounted } from "vue";
import router from "@/router";
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import { currentAffairsIssues } from "@/components/WelcomePages/currentAffairsData";

export default {
  components: { WelcomeHeader, WelcomeFooter },
  setup() {
    const issues = currentAffairsIssues.filter((i) => i.published);

    const toBengali = (n) => {
      const bn = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
      return String(n).split("").map((c) => bn[parseInt(c)] ?? c).join("");
    };

    const goToIssue = (issue) => router.push({ name: issue.routeName });

    const setMeta = (attrs) => {
      const selector = attrs.property ? `meta[property="${attrs.property}"]` : `meta[name="${attrs.name}"]`;
      let el = document.querySelector(selector);
      if (!el) { el = document.createElement("meta"); document.head.appendChild(el); }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };

    onMounted(() => {
      window.scrollTo(0, 0);
      document.title = "সাম্প্রতিক সমাচার — মাসভিত্তিক কারেন্ট অ্যাফেয়ার্স | বিসিএস প্রস্তুতি";
      setMeta({ name: "description", content: "বিসিএস ও চাকরির প্রস্তুতির জন্য মাসভিত্তিক বাছাইকৃত সাম্প্রতিক তথ্য — বাংলাদেশ, আন্তর্জাতিক, বিজ্ঞান ও প্রযুক্তি এবং ক্রীড়াঙ্গন।" });
      setMeta({ name: "robots", content: "index, follow" });
      setMeta({ property: "og:title", content: "সাম্প্রতিক সমাচার — মাসভিত্তিক কারেন্ট অ্যাফেয়ার্স" });
      setMeta({ property: "og:description", content: "মাসভিত্তিক বাছাইকৃত সাম্প্রতিক তথ্য — সম্পূর্ণ ফ্রি।" });
      setMeta({ property: "og:url", content: "https://www.bcsprostuti.com/current-affairs" });
      setMeta({ property: "og:type", content: "website" });
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
      canonical.href = "https://www.bcsprostuti.com/current-affairs";
    });

    return { issues, toBengali, goToIssue };
  },
};
</script>

<style scoped>
.ca-container { max-width: 1080px; margin: 0 auto; padding: 0 20px; }

.ca-hero {
  background: linear-gradient(135deg, #191B47 0%, #10265c 55%, #0095FF 160%);
  color: #fff; padding: 64px 0 56px; text-align: center;
}
.ca-badge {
  display: inline-block; font-size: 0.7rem; font-weight: 700; letter-spacing: 0.07em;
  text-transform: uppercase; color: #7CC6FF; background: rgba(0,149,255,0.15);
  border: 1px solid rgba(0,149,255,0.32); padding: 4px 14px; border-radius: 999px; margin-bottom: 16px;
}
.ca-hero h1 { font-size: 2.1rem; font-weight: 800; margin: 0 0 12px; }
.ca-hero p { max-width: 640px; margin: 0 auto; font-size: 0.98rem; line-height: 1.7; color: #c7d2e6; }

.ca-list { background: #f4f6fb; padding: 48px 0 72px; }
.ca-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 22px; }

.ca-card {
  background: #fff; border: 1px solid #e5e9f2; border-radius: 16px; padding: 24px;
  cursor: pointer; transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  display: flex; flex-direction: column;
}
.ca-card:hover { transform: translateY(-4px); box-shadow: 0 14px 34px rgba(25,27,71,0.12); border-color: #0095FF; }
.ca-card-top { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
.ca-cal { font-size: 1.9rem; line-height: 1; }
.ca-card-top h2 { font-size: 1.25rem; font-weight: 800; color: #191B47; margin: 0 0 2px; }
.ca-count { font-size: 0.82rem; font-weight: 600; color: #0095FF; }
.ca-summary { font-size: 0.9rem; line-height: 1.65; color: #5b6478; margin: 0 0 16px; flex: 1; }

.ca-chips { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 18px; }
.ca-chip {
  font-size: 0.72rem; font-weight: 600; color: #334155;
  background: color-mix(in srgb, var(--accent) 12%, #fff);
  border: 1px solid color-mix(in srgb, var(--accent) 34%, #fff);
  border-left: 3px solid var(--accent);
  padding: 4px 10px; border-radius: 6px;
}
.ca-link {
  display: inline-flex; align-items: center; gap: 6px; font-size: 0.9rem; font-weight: 700; color: #0095FF;
}

.ca-card--soon { cursor: default; opacity: 0.72; border-style: dashed; background: #fbfcfe; }
.ca-card--soon:hover { transform: none; box-shadow: none; border-color: #d7ddea; }
.ca-card--soon .ca-count { color: #94a3b8; }

@media (max-width: 600px) {
  .ca-hero h1 { font-size: 1.7rem; }
  .ca-grid { grid-template-columns: 1fr; }
}
</style>
